// The API's ingress normalization rejects invalid payloads with a 422 whose
// body carries the exact Ajv errors. Axios collapses that to "Request failed
// with status code 422", which is what used to reach the sync status and OPS.
export function apiErrorDetail(responseData) {
  if (!responseData || typeof responseData !== "object") {
    return null;
  }
  const parts = [];
  if (responseData.taskType) {
    parts.push(responseData.taskType);
  }
  if (responseData.taskId) {
    parts.push(`task ${responseData.taskId}`);
  }
  if (responseData.quarantineReason) {
    parts.push(responseData.quarantineReason);
  }
  if (Array.isArray(responseData.validationErrors)) {
    const shown = responseData.validationErrors
      .slice(0, 3)
      .map((e) => `${e?.instancePath || ""} ${e?.message || ""}`.trim())
      .filter(Boolean);
    parts.push(...shown);
    const remaining = responseData.validationErrors.length - shown.length;
    if (remaining > 0) {
      parts.push(`+${remaining} más`);
    }
  }
  if (parts.length === 0 && responseData.error) {
    parts.push(String(responseData.error));
  }
  return parts.length ? parts.join(" — ") : null;
}
